import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, Renderer2, TemplateRef } from "@angular/core";
import { NzFormatBeforeDropEvent, NzFormatEmitEvent, NzTreeBaseService, NzTreeNode, NzTreeNodeOptions } from "ng-zorro-antd/core/tree";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { NzTreeNodeBuiltinComponent } from "ng-zorro-antd/tree";
import { Observable, fromEvent, takeUntil } from "rxjs";

@Component({
  selector: "ui-tree-node[builtin]",
  exportAs: "uiTreeBuiltinNode",
  templateUrl: "tree-node.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiTreeNodeBuiltinComponent extends NzTreeNodeBuiltinComponent implements OnInit {
  /**
   * for global property
   */
  @Input() public icon = "";
  @Input() public title = "";
  @Input() public isLoading = false;
  @Input() public isSelected = false;
  @Input() public isDisabled = false;
  @Input() public isMatched = false;
  @Input() public isExpanded!: boolean;
  @Input() public isLeaf!: boolean;
  @Input() public isChecked?: boolean;
  @Input() public isHalfChecked?: boolean;
  @Input() public isDisableCheckbox?: boolean;
  @Input() public isSelectable?: boolean;
  @Input() public canHide?: boolean;
  @Input() public isStart: boolean[] = [];
  @Input() public isEnd: boolean[] = [];
  @Input("uiTreeNode") public nzTreeNode!: NzTreeNode;
  @Input("uiShowLine") @InputBoolean() public nzShowLine?: boolean;
  @Input("uiShowExpand") @InputBoolean() public nzShowExpand?: boolean;
  @Input("uiCheckable") @InputBoolean() public nzCheckable?: boolean;
  @Input("uiAsyncData") @InputBoolean() public nzAsyncData?: boolean;
  @Input("uiHideUnMatched") @InputBoolean() public nzHideUnMatched = false;
  @Input("uiSelectMode") @InputBoolean() public nzSelectMode = false;
  @Input("uiShowIcon") @InputBoolean() public nzShowIcon = false;
  @Input("uiExpandedIcon") public nzExpandedIcon?: TemplateRef<{ $implicit: NzTreeNode; origin: NzTreeNodeOptions }>;
  @Input("uiTreeTemplate") public nzTreeTemplate: TemplateRef<{ $implicit: NzTreeNode; origin: NzTreeNodeOptions }> | null = null;
  @Input("uiBeforeDrop") public nzBeforeDrop?: (confirm: NzFormatBeforeDropEvent) => Observable<boolean>;
  @Input("uiSearchValue") public nzSearchValue = "";
  @Input("uiDraggable") public nzDraggable = false;
  @Output("uiClick") public readonly nzClick = new EventEmitter<NzFormatEmitEvent>();
  @Output("uiDblClick") public readonly nzDblClick = new EventEmitter<NzFormatEmitEvent>();
  @Output("uiContextMenu") public readonly nzContextMenu = new EventEmitter<NzFormatEmitEvent>();
  @Output("uiCheckBoxChange") public readonly nzCheckBoxChange = new EventEmitter<NzFormatEmitEvent>();
  @Output("uiExpandChange") public readonly nzExpandChange = new EventEmitter<NzFormatEmitEvent>();
  @Output("uiOnDragStart") public readonly nzOnDragStart = new EventEmitter<NzFormatEmitEvent>();
  @Output("uiOnDragEnter") public readonly nzOnDragEnter = new EventEmitter<NzFormatEmitEvent>();
  @Output("uiOnDragOver") public readonly nzOnDragOver = new EventEmitter<NzFormatEmitEvent>();
  @Output("uiOnDragLeave") public readonly nzOnDragLeave = new EventEmitter<NzFormatEmitEvent>();
  @Output("uiOnDrop") public readonly nzOnDrop = new EventEmitter<NzFormatEmitEvent>();
  @Output("uiOnDragEnd") public readonly nzOnDragEnd = new EventEmitter<NzFormatEmitEvent>();
  @Output() public readonly uiHover = new EventEmitter<NzTreeNode>();

  private zone: NgZone;
  private elRef: ElementRef<HTMLElement>;

  constructor(nzTreeService: NzTreeBaseService, ngZone: NgZone, renderer: Renderer2, elementRef: ElementRef<HTMLElement>, cdr: ChangeDetectorRef) {
    super(nzTreeService, ngZone, renderer, elementRef, cdr);
    this.zone = ngZone;
    this.elRef = elementRef;
  }

  public ngOnInit(): void {
    this.zone.runOutsideAngular(() => {
      fromEvent(this.elRef.nativeElement, "mouseenter")
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => {
          if (!this.isDisabled) {
            this.zone.run(() => this.uiHover.emit(this.nzTreeNode));
          }
        });
    });
  }

  public handleClick(evt: MouseEvent): void {
    if (this.nzTreeNode.origin.readonly) {
      return;
    }

    this.clickSelect(evt);
  }
}
